import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import BryxColors from "../types/theme";
import Button from "@mui/material/Button";
export const SupportedChipColors = {
    red: "red",
    green: "green",
};
const getColorStylesForColor = (color, mode, on) => {
    const themeMap = {
        red: {
            default: {
                backgroundColor: on ? BryxColors.brand3(mode) : "unset !important",
                border: `1px solid ${on ? BryxColors.brandPrimary(mode) : BryxColors.notify(mode, "inactive")}`,
                color: on ? BryxColors.brandPrimary(mode) : BryxColors.notify(mode, "inactive"),
            },
            hover: {
                backgroundColor: BryxColors.brand3(mode),
                border: `1px solid ${BryxColors.brandPrimary(mode)}`,
                color: BryxColors.brandPrimary(mode),
            },
        },
        green: {
            default: {
                backgroundColor: on ? "#F1FFFB" : "unset !important",
                border: `1px solid ${on ? BryxColors.lightNotify("complete") : BryxColors.notify(mode, "inactive")}`,
                color: on ? BryxColors.lightNotify("complete") : BryxColors.notify(mode, "inactive"),
            },
            hover: {
                backgroundColor: "#F1FFFB",
                border: `1px solid ${BryxColors.lightNotify("complete")}`,
                color: BryxColors.lightNotify("complete"),
            },
        },
    };
    return themeMap[color];
};
const BryxChip = styled((props) => {
    // scrub `on`, `color`, and disallow use of `variant`. can't do this with Omit, since we reference it in the theme function below
    const cleanProps = { ...props, variant: undefined, on: undefined, color: undefined };
    const { label, maxLength, ...rest } = cleanProps;
    const labelValue = maxLength && typeof label === "string" && label.length > maxLength ? label.substring(0, maxLength) + "..." : label;
    return (_jsx(Button, { ...rest, disableRipple: true, variant: props.on ? "contained" : "outlined", children: labelValue || undefined }));
})(({ on, theme, color = "red" }) => {
    const mode = theme.palette.mode;
    const { default: colorStyles, hover: hoverColorStyles } = getColorStylesForColor(color, mode, on);
    return {
        // a lot of this is from BryxButton
        borderRadius: "4px",
        fontSize: "13px",
        padding: "8px 12px",
        boxShadow: "none",
        fontWeight: 400,
        lineHeight: "18px",
        textTransform: "none",
        fontStyle: "normal",
        ...colorStyles,
        "&:hover": {
            ...hoverColorStyles,
            boxShadow: "none",
            "& span": {
                color: hoverColorStyles?.color,
            },
        },
        "& span": {
            // This is for BryxTimeChip specifically to cover labels that contain a <span>
            color: colorStyles.color,
        },
    };
});
export default BryxChip;
